import academyApi from '@/api/academyApi'
import { Academy } from '@/dto'
import commonRepo from '@/repository/common.repo'

import { makeAdapter } from './Adapter'
import type Controller from './Controller'

class AcademyController implements Controller {
  adapter = makeAdapter({
    from(data: res.Academy): Academy {
      return new Academy(data)
    },
    toAcademy(academy: Academy): req.Academy {
      return {
        name: academy.name,
        email: academy.email,
      }
    },
  })

  async fetchMyAcademy() {
    const { data } = await academyApi.getAcademies()

    return this.adapter.from(data)
  }

  async changeMyAcademy(academy: Academy) {
    await academyApi.patchAcademies(this.adapter.toAcademy(academy))
  }

  async changeCustomerType(data: req.AcademyCustomerType) {
    await academyApi.patchCustomerType(data)
  }

  async patchNiceAuthSuccess({ encodeData }, type: req.NiceAuthSuccessType) {
    const { data } = await academyApi.patchNiceAuthSuccess({ encodeData }, type)
    return data?.data
  }

  postMetaData = async (data: req.AcademyMetaData) => {
    await academyApi.postMetaData(data)
  }
  patchMetaData = async (data: req.AcademyAttendanceSmsService) => {
    await academyApi.patchMetaData(data)
  }
  refetchAfterPutMetaData = async (data: req.PutAcademyMetaData) => {
    await academyApi.putMetaData(data, 'v1')
    commonRepo.academy = await this.fetchMyAcademy()
  }

  postFreePremium = async (data: req.FreePremium) => {
    await academyApi.postFreePremium(data)
  }

  postSubscriptionOffer = async (
    ...params: Parameters<typeof academyApi.postSubscriptionOffer>
  ) => {
    await academyApi.postSubscriptionOffer(...params)
  }

  initializeAcademy = async () => {
    await academyApi.initializeAcademy()
  }
}

export const academyController = new AcademyController()
